"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  route: {
    dashboard: '我的工作台',
    desktop: '领导桌面',
    authApprove: '授权审批',
    attentionShip: '关注船舶',
    attentionBuz: '我的收藏',
    vesselDashboard: '单船画像',
    board: '工作台',
    waitToList: '待办事项',
    msgList: '消息列表',
    guide: '引导页',
    permission: '用户与权限',
    organization: '组织与流程配置',
    rolePermission: '角色权限',
    pagePermission: '菜单配置',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    Crew: '船员管理',
    crewpersonnel: '船员人事',
    CrewListMgr: '船员池',
    ChangeManMgr: '船员需求',
    ResumeListMgr: '船员简历',
    InterViewMgr: '船员面试',
    leaveMgr: '船员离司',
    Deployment: '船员调配',
    CrewDeployStatistic: '在船船员监控',
    Tsfshowlist: '调配管理',
    TransOrderMgr: '调令管理',
    UserEdit13Top4: '离船评估',
    UserEdit13Records: '考核待审批跟踪',
    Cert: '船员证件',
    CertManage: '船员证件查询',
    CertHandOver: '证书交接记录',
    CertMonitoring: '在船船员证书监控',
    Onboard: '在船管理',
    CrewHandOver: '换班待办',
    CrewLeave: '因私申请',
    CrewAssess: '船员考核',
    CrewTrain: '船员培训',
    CrewTrainingStatic: '船员培训统计',
    BasicData: '船员基础数据',
    CertStandardMgr: '证书标准维护',
    CertInfoMgt: '证书信息维护',
    Interface: '数据交换',
    AccountSrv: '账号信息同步',
    crewdeploymentstatistic: '船员调配统计',
    CrewTrainings: '船员培训',
    ShoreBased: '岸基培训',
    ComYearPlan: '培训计划',
    Cotrnrec: '培训记录',
    COTRNAPPRFilter: '培训效果评估',
    TrainingNeeds: '培训需求',
    OrientationMgt: '派前培训管理',
    assessmentRecord: '培训情况查询',
    ShipBoard: '船舶培训',
    safetyOfficer: '安全员培训管理',
    MGT: '培训基础数据',
    BasicTrndrill: '培训项目设置',
    Materials: '培训材料',
    InfoManager: '船员通用培训',
    CrewSalary: '船员薪酬',
    CrewSaloryProcess: '船员薪酬流程',
    SalaryStandard: '工资标准设置',
    PrDutyScaleMgr: '岗位工资标准',
    Base_PrBase3Add: '派员单位标准',
    ShipScaleMgr: '单船工资标准',
    WpSailorScaleMgr: '个人工资标准',
    Compute: '工资计算',
    Useandstop: '启停薪处理',
    Adjustment: '工资细目调整',
    PractDept: '船员工资动态提交',
    Actsalary: '动态工资生成',
    Prfa05addship: '月度工资总清',
    Payment: '工资发放',
    Useredit15: '船员银行账户维护',
    RemmitMgr: '工资发放管理',
    SalaryQueryMW: '工资单查询',
    SalaryFinance: '工资业财管理',
    ShowSapFrame2: '工资付款单',
    WageReturn: '工资退款处理',
    ShowSapFrame3: '月度成本实际',
    ShowSapFrame: '月度成本预估',
    SalaryBasicData: '工资基础数据',
    PrItemMgr: '工资项目设置',
    CrewFare: '船员费用',
    SettlementCenter: '费用结算',
    FareInput: '发票信息登记',
    FormGenFrame: '付款申请',
    FormFrame: '付款审批',
    InterfacePending: '付款单支付查询',
    FormChkFrame: '发票支付查询',
    Table: 'Table',
    dynamicTable: '动态 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 内编辑',
    complexTable: '表格',
    componentTable: '组件-表格',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '系统日志',
    excel: 'Excel',
    exportExcel: '导出 Excel',
    selectExcel: '导出 已选择项',
    mergeHeader: '导出 多级表头',
    uploadExcel: '上传 Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    profile: '个人信息',
    country: '国家/地区维护',
    standardCode: '标准化代码',
    countyInfo: '国家地区信息',
    GoodsType: '货物种类',
    currency: '币种信息',
    rateAssert: '汇率信息',
    portAssert: '港口信息维护',
    cityInformation: '城市信息',
    bankInformation: '银行信息',
    aboutInformation: '相关方信息',
    companyInformation: '公司信息',
    costAccount: '业务科目',
    aclTable: '数据库表',
    sparePurchaseApply: '备件申领',
    sparePurchaseDetail: '申领详细',
    sparePurchaseCreate: '申领新增',
    sparePurchaseList: '备件采购',
    cart: '购物车',
    shipRepair: '修船管理',
    repairItem: '修理项目库',
    dockRepairPlan: '坞修计划',
    repairOrder: '修船订单',
    repairLegacy: '修理遗留记录',
    repairShip: '船舶修理',
    statutory: '法定管理',
    shipCertificate: '船舶证书管理',
    shipCertDict: '船舶证书字典',
    shipSurvey: '船舶检验',
    surveyOrder: '检验订单',
    statutoryChange: '法规跟踪',
    taskTracking: '任务跟踪',
    dictionary: '证书字典',
    surveyItem: '检验项目库',
    attachment: '安全备件库存',
    materiel: '安全物料库存',
    applyListName: '申请列表',
    busComponentTop: '业务组件模块',
    busComponent: '业务组件',
    busTable: '展示表格',
    manage: '后台管理',
    activityType: '活动类型',
    system: '系统管理',
    monitor: '系统监测',
    personnel: '人员信息',
    purchaseStock: '采购与库存',
    stockBase: '基础数据',
    materialType: '物资类别',
    locationInfo: '库位信息',
    materialStock: '物资库',
    materialApplyTem: '物资申请模板',
    searchTableName: '全文检索配置',
    devieMenuBaseData: '基础信息管理',
    deviceMgt: '设备管理',
    devicePeriod: '保养级别',
    deviceCategory: '设备类别',
    sparePartMgt: '备件信息',
    shipDeviceMgt: '船舶设备维护',
    shipDeviceQuery: '船舶设备信息',
    deviceStandard: '标准设备编码',
    deviceProduct: '设备产品管理',
    composeWork: '组合工作管理',
    timerMgt: '计时器管理',
    timerUpdate: '计时器更新',
    timerDefine: '计时器定义',
    arrangeWork: '工作首排',
    performWork: '设备保养执行',
    deviceFault: '设备故障管理',
    planReport: '保养计划与报告',
    manufacture: '制造商管理',
    workCard: '工单管理',
    reportHistory: '工单历史记录',
    reportStatistic: '工单统计',
    resWorkCard: '遗留工单管理',
    cancelWorkCard: '取消工单管理',
    periodWork: '定期检查执行',
    loMgt: '润滑油管理',
    loSampleAnalysis: '润滑油化验报告',
    loReport: '润滑油月报表',
    loDevice: '设备润滑油用途定义',
    safetyDevice: '安全设备管理',
    standardCheckWork: '工作标准配置',
    safetyDevicesInventory: '安全设备清单',
    regularInspection: '定期检查',
    regularInspectionRecord: '定期检查记录',
    qualityFileMgt: '体系管理',
    manual: '文件手册',
    standard: '标准管理',
    qualityFile: '文件管理',
    qualityRecord: '记录表格',
    benchmark: '体系对标',
    massTempWork: '群发临时工单',
    learnAssign: '学习指派',
    exam: '体系考试',
    examQuestion: '考试题库',
    examAssign: '考试指派',
    examTest: '在线考试',
    summary: '考试统计',
    circular: '通告与法规',
    circularManager: '通告与法规管理',
    qualityImplement: '体系运行',
    qualitySuggest: '体系改进',
    moc: '变更管理',
    shoreReview: '公司管理评审',
    shipReview: '船舶管理评审',
    marine: '海务管理',
    voyVessel: '航次执行',
    marineCompanyChart: '出版物配备标准',
    marineChart: '船舶海图及出版物',
    marineVoyNewRoute: '新航次或者港口评审',
    marineVoyTrack: '航次跟踪查询',
    marineRiskArea: '高风险国家/港口',
    workConfig: '待办配置管理',
    msgRemindConfig: '消息提醒配置',
    sparePurchasingManage: '备件采购管理',
    materialPurchasingManage: '物资采购管理',
    materialApply: '物资申请',
    materialOrder: '定单管理',
    spareApply: '备件申请',
    purchaseHome: '采购首页',
    spareOrder: '定单管理',
    allocateManage: '调拨单管理',
    applySignManage: '申请签收',
    spsInventoryRecordManage: '库存管理',
    mtrInventoryRecordManage: '库存管理',
    inventoryVerification: '库存盘点',
    logisticsTrackManage: '物流跟踪',
    spareStockingManage: '备件库存管理',
    prosOrderMainManage: '流向管理',
    /** 物资*/
    mtrLogisticsTrackManage: '物流跟踪',
    mtrApplySignManage: '申请签收',
    materialStockingManage: '物资库存管理',
    mtrAllocateManage: '调拨单管理',
    /* 集中采购管理 */
    centralizedProManagement: '集中采购管理',
    cenProAgreement: '集采协议（待）',
    centralizedStatistical: '集采统计分析（待）',
    /* 统计分析 */
    statisticalAnalysis: '统计分析',
    drugListManage: '药品清单',
    onBoardPartsList: '在船备件清单',
    onBoardMaterialList: '在船物资清单',
    spareApplyTracking: '备件申请跟踪（待）',
    materialApplyTracking: '物资申请跟踪（待）',
    sparePartsStatistical: '备件库存统计分析（待）',
    materialPartsStatistical: '物资库存统计分析（待）',
    budgetPerformance: '预算执行情况（待）',
    /* 新造船管理 */
    newShipManagement: '新造船管理',
    shipContractManagement: '新造船合同管理（待）',
    warrantyManagement: '保修单管理（待）',
    /* 结算中心 */
    accountingCenter: '结算中心',
    accountBasic: '基础数据',
    paymentManage: '付款管理',
    receiptManage: '收款管理',
    reportManage: '报备管理',
    relatedTransaction: '关联交易',
    departmentSubjects: '部门科目配置',
    invoiceRegister: ' 发票登记',
    registrationAdvance: '预付登记',
    applicationForm: '预/应付申请单',
    outlineAgreement: '框架协议',
    alarmSystem: '报备记录',
    actualPayment: '实付款登记',
    receivableRegister: '应收登记（待）',
    transactionAmount: '关联交易配置（待）',
    tradeStatistics: '关联交易统计（待）',
    contractManagement: '非租船合同管理',
    generalContract: '非租船合同（待）',
    foreignShipManagement: '外管船管理',
    feeRegistration: '费用登记（待）',
    accountApproval: '费用审批（待）',
    budgetManagement: '预算管理（待）',
    costAccountManagement: '业务科目管理（待）',
    vesselReport: '船舶报文',
    vesselBasic: '报文管理',
    vesselReportReq: '报文',
    shipMonthlyReport: '船舶月度报文',
    shipDynamic: '船舶动态（待）',
    monitorCcs: '报文接口监测',
    // 报错点，先改

    interestedParties: '相关方管理',
    integratedManage: '相关方管理',
    supplierManage: '供应商管理',
    otherPartiesManage: '其他相关方管理',
    customerManage: '客户管理',
    timeAssessment: '供应商定期评估',
    frequencyConfiguration: '服务类型配置',
    evaluationMonitor: '相关方评估监控',
    CommVesselView: '船舶通讯配置',
    TableConfigView: '同步表配置',
    LogFileView: '同步文件监控',
    LogAttachmentView: '同步附件监控',
    VscLog: '船岸同步',
    VesselMaintenanceManage: '船端系统升级',
    // 预算管理
    budget: '预算管理',
    annualBudget: '年度预算',
    rollBudget: '滚动预算（待）',
    additionalBudget: '追加预算（待）',
    budgetControlAnalysis: '预算管控对比分析（待）',
    budgetReportStatistics: '预算执行报表统计（待）',
    // 业财管理
    financeManage: '业财管理',
    ruleConfig: '业财规则配置',
    fiReceiptsManage: '万能单据管理',
    payManage: '预/应付申请单',
    financeDataSearch: '业财数据查询',
    financeOrder: '业财定单查询',
    dockSearch: '坞修统计查询',
    receiptMonth: '业财库存统计',
    fiReceiptSearch: '万能单据查询',
    dataMonitor: '交互数据查询',
    sendMonitor: '与业财集成平台',
    recieveMonitor: '与内部模块',
    fiBizInOut: '库存动态',
    accountGroupManage: '核算项目组管理',
    categoryCharge: '业务科目品种映射',
    safety: '安全管理',
    antiPollution: '防污染',
    bilgeWater: '机舱污水排放',
    ballastWater: '压载水管理',
    garbageDispose: '船舶垃圾管理',
    preventAir: '船舶防止大气污染',
    portFacility: '港口缺少接收设施',
    workPlan: '每日工作计划',
    WorkPlanReview: '工作计划审核',
    unqualifiedFindRecord: '不合格管理',
    nonconform: '不合格',
    ncRecord: '不合格管理',
    ncReport: '不合格分析报告',
    workPlanConfirm: '工作计划确认',
    workBeforeConfirm: '工前会确认',
    completedFill: '完工填报',
    completedExamine: '完工审核',
    risk: '风险管理',
    riskLib: '风险库',
    riskAssess: '风险评估',
    shipMeeting: '船舶会议管理',
    shoreMeeting: '船舶会议管理(岸端)',
    vesselMeeting: '船舶会议管理(船端)',
    shipMeetingDefine: '船舶会议议程定义',
    meeting: '会议管理',
    meetingManager: '会议决议管理',
    meetingTask: '会议决议待办',
    meetingMonitor: '会议决议监控',
    meetingHistory: '会议决议历史查询',
    audit: '审核与检查',
    shoreAuditPlan: '公司年度审核计划',
    shipAuditPlan: '船舶年度审核计划与跟踪',
    auditor: '内审员管理',
    shoreInnerAudit: '公司内审',
    shoreExternalAudit: '公司外审',
    shipInnerAudit: '船舶内审',
    shipExternalAudit: '船舶外审',
    onboardInspect: '登轮检查',
    externalInspect: '外部机构检查',
    hiddenDanger: '隐患与险情',
    shipFindRecord: '船舶发现项管理',
    hidden: '隐患排查',
    hiddenMonitor: '隐患排查监控',
    danger: '险情报告',
    dangerMonitor: '险情报告监控',
    emergency: '应急管理',
    drillTrainDefine: '应急演习/培训项目定义',
    drillTrainShore: '演习/培训（岸端）',
    drillTrainVessels: '演习/培训',
    drillTrainTemporaryPlan: '临时演习/培训项目定义',
    emergencyPlanScene: '应急准备场景定义',
    emergencyPlanHandle: '应急准备/事故处理',
    emergencyPreparedness: '应急准备',
    accidentHandling: '应急事故处理'
  },
  navbar: {
    dashboard: '我的工作台',
    changeRole: '切换角色',
    logOut: '退出登录',
    profile: '个人信息',
    modifyPassWord: '修改密码',
    operateLogs: '操作日志',
    adviseFeedBack: '建议反馈',
    aboutUs: '关于我们',
    theme: '换肤',
    size: '布局大小',
    AccountNo: '账号编码',
    LoginName: '登录名',
    ChineseName: '中文姓名',
    AccountID: '账号id',
    defaultRole: '默认角色',
    AffiliatedOrganization: '所属组织',
    AffiliatedOrganizationID: '所属组织id',
    Organizationcode: '所属组织代码',
    position: '职位',
    Numberofvisits: '访问次数',
    Recentlyloggedin: '最近登录',
    chooseMonth: '选择月'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    signIn: '登录',
    username: '账号',
    password: '密码',
    checkCode: '验证码',
    userHolder: '请输入账号',
    passwordHolder: '请输入密码',
    capsLock: '大写锁定',
    checkCodeHolder: '请输入验证码',
    userError: '请输入账号',
    passwordRequire: '请输入密码',
    passwordError: '密码至少8位',
    checkRequire: '请输入验证码',
    checkError: '验证码为4位',
    loginErrTip: '用户名或密码错误',
    loginServerErrTip: '系统故障，请联系管理员处理',
    resetTip: '密码已过期，请设置新密码?',
    giveUp: '放弃修改',
    resetPassword: '修改密码',
    newPassword: '新密码',
    oldPassword: '旧密码',
    confirmPassword: '确认密码',
    confirmModify: '确认修改',
    modifyTip: '密码已过期，请重新设置密码',
    oldPwd: '请输入原密码',
    newPwd: '请输入新密码',
    verifyNewPwd: '再次输入新密码',
    resendActivationEmail: '重发激活邮件'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    status: '状态',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    emptyText: '暂无数据',
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: 'id',
    date: '时间',
    No: '序号'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)',
    exportSuccess: '导出成功',
    chooseOneMsg: '请选择需要导出的数据',
    exportAll: '导出全部',
    exportSelection: '导出已勾选'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  /* ke拖拽弹窗 */
  dragDialog: {
    fullScreen: '全屏',
    restore: '还原',
    close: '关闭',
    readFlag: '标记为已读',
    focus: '收藏',
    unFocus: '取消收藏'
  },
  /* btn标题 */
  btn: {
    viewHistory: '查看历史版本',
    update: '更新',
    add: '新增',
    authorize: '授权',
    batchDel: '批量删除',
    del: '删除',
    edit: '编辑',
    save: '保存',
    submit: '提交',
    download: '下载',
    export: '导出',
    exportTemplate: '导出(模板)',
    import: '导入',
    print: '打印',
    reset: '重置',
    option: '操作',
    send: '发送',
    close: '关闭',
    activate: '激活',
    confirm: '确定',
    cancel: '取消',
    search: '查询',
    invalid: '作废',
    menuEdit: '目录维护',
    versionEdit: '版本维护',
    historyEdit: '体系变更记录',
    moduleEdit: '模块出题维护',
    validFlag: '是否生效',
    requireFlag: '是否必考',
    typeEdit: '分类维护',
    crewOnBoard: '船员上船',
    crewOnVacation: '船员公休',
    temporaryStorage: '暂存',
    initialAssessment: '初始评估',
    timeAssessment: '定期评估',
    sendMasterData: '发送主数据平台',
    authorityAss: '权限分配',
    blackList: '加入黑名单',
    copyAdd: '拷贝新增',
    statisticalSummary: '统计汇总',
    addShop: '追加供应商',
    cancelCancellation: '取消注销',
    cancellation: '注销',
    orgMigration: '组织迁移',
    templateDownload: '模板下载',
    monthPlanAdd: '月度计划',
    monthReportAdd: '月度报告',
    yearPlanAdd: '年度计划',
    batchInspection: '批量检查',
    aloneReport: '检查',
    maintenanceCode: '编码维护',
    adjustCode: '调整设备编码',
    markFinish: '标记完成',
    markClose: '关闭',
    markActive: '激活',
    recoverRemain: '工单恢复',
    archive: '归档',
    renewal: '换证',
    generate: '生成',
    writeOff: '红冲',
    section: '切片',
    delSection: '删除切片',
    copy: '复制',
    clear: '清空',
    addProject: '维护修理工程',
    next: '下一封',
    up: '上一封',
    newApply: '新增申请',
    saveApply: '保存申请',
    invalidApply: '作废申请',
    createTransfer: '生成调拨单',
    newInquiry: '发起询价',
    submitInquiry: '提交询价',
    invalidInquiry: '作废询价',
    fillQuote: '录入报价',
    importQuote: '导入报价',
    invalidQuote: '作废报价',
    newCompare: '发起比价',
    editCompare: '编辑比价',
    savePo: '保存定单',
    invalidPo: '作废定单',
    sendPo: '发送下单邮件',
    confirmPo: '确认下单',
    saveDelivery: '保存物流',
    confirmStock: '确认备货',
    saveReceive: '保存签收',
    confirmReceive: '确认签收',
    scoreReceive: '签收评分',
    saveTransfer: '保存调拨',
    invalidTransfer: '作废调拨',
    newTransfer: '发起调拨',
    new: '新增',
    look: '查看详情',
    updataChartVer: '更新最新版本',
    addVoyage: '新增航次计划',
    submitVoyPassage: '提交航行计划',
    addCargoPort: '获取装卸货港口',
    editCargoPort: '编辑装卸货港口',
    lookCargoPort: '查看装卸货港口',
    addBunker: '新增油类转移操作',
    editBunker: '编辑油类转移操作',
    delBunker: '删除油类转移操作',
    lookBunker: '查看油类转移操作',
    addSupplier: '新增供应商',
    spare: '备件',
    relevantData: '相关资料',
    transfer: '移库',
    supplier: '供应商',
    newTeam: '新增船队',
    viewAccount: '查看账号',
    newShip: '新增船舶',
    delShip: '删除船舶',
    changeTeam: '更换船队',
    chooseAccount: '指定账号',
    manageDel: '删除指定账号',
    manageChangeTeam: '指定账号更换船队',
    changeTime: '批量更改时间',
    createInfo: '生成内部供应商信息',
    newAccount: '新增账号',
    delAccount: '删除账号',
    changeAccount: '更改组织',
    change: '更改上级组织',
    permit: '赋值权限',
    addPart: '新增兼任角色',
    delPart: '删除兼任角色',
    shipPriciple: '负责船舶',
    valid: '注销',
    reSend: '数据包重发',
    temp: '模板下载',
    addNode: '添加主节点',
    addTracking: '新增计划跟踪',
    sendMain: '发送主数据平台',
    detail: '详情',
    inStock: '入库',
    outStock: '出库',
    initStock: '初始化库存',
    back: '返回',
    markRead: '标记已读',
    upload: '上传',
    exportCurrentPage: '导出当前页',
    create: '创建',
    foreSpeak: '批量预约',
    forespeakSave: '预约/保存',
    downloadAttorney: '下载委托书',
    accreditSave: '授权/保存',
    nextStep: '下一步',
    previousStep: '上一步',
    confirmPrint: '确认并打印',
    feeConfirmation: '费用确认',
    bankSlipUpload: '水单上传',
    bankSlipUploadPlus: '已开票补传水单',
    applyInvoice: '开票申请',
    uploadInvoice: '水单上传/开票申请',
    refresh: '刷新',
    batchPrint: '批量打印',
    batchCancelAppointment: '批量取消预约',
    cancelAppointment: '取消预约',
    cancelAccredit: '取消授权'
  },
  /* 面板 */
  panel: {
    refresh: '刷新',
    edit: '编辑',
    hidden: '隐藏',
    addModule: '添加区块',
    recover: '恢复默认'
  },
  /* 联想控件 */
  associate: {
    placeholder: '请选择',
    countryCode: '国家地区代码',
    countryNameCn: '国家地区名称',
    countryNameEn: '国家地区英文名称',
    provinceCode: '省份代码',
    provinceNameCn: '省份名称',
    provinceNameEn: '省份英文名称',
    currencyCode: '币种代码',
    currencyName: '币种名称',
    currencySymbol: '币种符号',
    portCode: '港口代码',
    portNameEn: '港口名称(EN)',
    portNameCn: '港口名称',
    portCountry: '国家代码',
    portCountryNameCn: '国家名称',
    portCountryNameEn: '国家名称(En)',
    chargeCode: '费用代码',
    chargeName: '费用名称',
    chargeNameCn: '费用名称(CN)',
    childFlag: '是否有子科目',
    displayValueCn: '货物组别',
    displayValue: '货物组别(En)',
    cargoCode: '货物代码',
    cargoName: '货物名称',
    cargoNameCn: '货物名称(Cn)',
    officeCode: '组织机构代码',
    officeName: '组织机构名称',
    parentOfficeCode: '上级组织机构代码',
    parentOfficeName: '上级组织机构名称',
    officeType: '组织机构类型',
    roleCode: '角色代码',
    roleName: '角色名称',
    parentRoleCode: '上级角色代码',
    parentRoleName: '上级角色名称',
    vesselOfficeName: '所属部门',
    vesselTeamCode: '船队代码',
    vesselTeamName: '船队名称',
    vesselCode: '船舶代码',
    vesselEnName: '船舶英文名称',
    vesselCnName: '船舶中文名称',
    vesselType: '船型',
    validFlag: '退役标记',
    ownership: '是否自有船',
    onService: '在役',
    unService: '退役',
    onBuilding: '在建',
    companyCode: '公司编码',
    companyName: '公司名称',
    companyNameCn: '公司名称(CN)',
    companyNameEn: '公司名称(EN)',
    parentCompanyCode: '上级公司编码',
    parentCompanyName: '上级组织机构名称',
    deptCode: '部门代码',
    deptName: '部门名称',
    ripCode: '相关方代码',
    hcbCode: '主数据代码',
    ripNameCn: '相关方名称(CN)',
    ripNameEn: '相关方名称(EN)',
    shipOwnerNameCn: '船舶所有人(CN)',
    shipOwnerNameEn: '船舶所有人(EN)',
    shipManageCompanyNameCn: '船舶管理公司(CN)',
    shipManageCompanyNameEn: '船舶管理公司(EN)',
    operateCompanyNameCn: '经营公司（CN）',
    operateCompanyNameEn: '经营公司（EN）',
    singleCompanyCn: '单船公司（CN）',
    singleCompanyEn: '单船公司（EN）',
    locationCode: '库位编码',
    locationNameCn: '库位名称(中文)',
    locationNameEn: '库位名称(英文)',
    cityCode: '城市代码',
    cityNameCn: '城市名称(CN)',
    cityNameEn: '城市名称(EN)',
    province: '省份',
    countryCodePlace: '国家/地区',
    userCode: '账号代码',
    userName: '中文名称',
    userNameEn: '英文名称',
    defaultOfficeName: '默认组织',
    defaultRoleName: '默认角色',
    poNo: '定单号',
    orderDate: '下单日期',
    currency: '定单币种',
    amount: '定单总金额',
    receiveStatus: '签收标识',
    employeeNo: '员工号',
    cnName: '中文姓名',
    enName: '英文姓名',
    duty: '职务',
    filterYes: '是',
    filterNo: '否',
    planYear: '年份',
    repairType: '计划类别',
    planDate: '计划日期',
    planDay: '计划修理天数',
    sipgCstCode: 'SIPG客户代码',
    creditCode: '统一社会信用代码',
    cstName: '受理人'
  },
  form: {
    dateTitle: '日期从',
    to: '至',
    startTime: '开始时间',
    endTime: '结束时间',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '查 询',
    reset: '重 置'
  },
  /* 过滤器 */
  filter: {
    quickSearch: '快速搜索',
    filter: '过滤器',
    keySearch: '关键字检索',
    pleaseEnterKeyWord: '请输入关键字',
    placeholder: '请选择',
    dataNone: '暂无数据',
    startDate: '开始时间',
    endDate: '结束时间',
    selected: '已选条件：',
    unSelected: '尚未选择',
    start: '开始',
    end: '结束',
    from: '从',
    to: '至',
    today: '今天',
    week: '一周',
    mouth: '一月内',
    year: '一年内'
  },
  dict: 'displayValueCn',
  labelTitle: 'title',
  /* 确认提示框 */
  confirmMsg: {
    title: '提示',
    submit: '确定',
    cancel: '取消',
    close: '关闭',
    confirm: '确认',
    continue: '继续'
  },
  /* 图片预览组件 */
  imagesViewer: {
    originalImageBtn: '查看原图',
    applyOriginImage: '申请索要原图',
    transitImage: '原图传输中',
    isApplyForOriginImage: '是否申请索要原图',
    isApplySuccess: '申请成功，等待返回原图'
  },
  validMsg: {
    msg: '您输入的数据不正确，请更正!'
  },
  status: {
    all: '全部',
    draft: '草稿',
    approving: '审批中',
    approved: '审批完成',
    applying: '申请中',
    reject: '拒绝',
    submit: '提交申请',
    viewDetail: '查看明细'
  },
  treeSelet: {
    placeholder: '请选择'
  },
  tips: {
    inputChineseTip: '只接受非中文字符',
    saveTip: '当前页面修改未保存，是否确定关闭?',
    title: '提示',
    submit: '确定',
    cancel: '取消',
    submitTip: '是否确认提交该记录',
    delTip: '是否确认删除该记录',
    delSuccess: '删除成功',
    delFail: '删除失败',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    submitSuccess: '提交成功',
    submitFail: '提交失败',
    restoreTips: '是否要恢复默认布局',
    restoreTips1: '提示',
    restoreTips2: '确定',
    restoreTips3: '取消'
  },
  loading: {
    save: '保存中...',
    loading: '加载中...',
    submit: '提交中...',
    send: '发送中...',
    export: '导出中...'
  },
  flollow: {
    followSuccess: '收藏成功',
    followCancel: '取消收藏成功'
  }
};